import { MonetateActionTypes } from '../../../enums/ActionEnums';
export const monetateActions = {
    init() {
        return { type: MonetateActionTypes.INIT };
    },
    load() {
        return { type: MonetateActionTypes.LOAD };
    },
    onHold() {
        return { type: MonetateActionTypes.ON_HOLD };
    },
    loaded() {
        return { type: MonetateActionTypes.LOADED };
    },
    fetchMonetateProducts(payload) {
        return { type: MonetateActionTypes.FETCH_PRODUCTS, payload };
    },
    setMonetateProducts(payload) {
        return { type: MonetateActionTypes.SET_PRODUCTS, payload };
    },
    getDeliveryPromise(payload) {
        return { type: MonetateActionTypes.GET_DELIVERY_PROMISE, payload };
    },
    setDeliveryPromise(payload) {
        return { type: MonetateActionTypes.SET_DELIVERY_PROMISE, payload };
    },
};
